export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getLocalStorageItem = (key) => {
  const value = JSON.parse(localStorage.getItem(key))

  if (!value) return null

  return value
}

export const isPathAvailable = (permissions, permission) => {
  return permissions.includes(permission)
}

export const isMobile = () => {
  const nav = navigator

  if (nav?.userAgentData && typeof nav.userAgentData.mobile === 'boolean') {
    return nav.userAgentData.mobile
  }

  if (typeof nav?.userAgent === 'string') {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      nav.userAgent
    )
  }

  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(max-width: 1024px)').matches
  }

  return false
}

export const isEveryFieldFilled = (values, skipKeyId = false) => {
  const areAllFieldsFilled = (fieldValue) => {
    if (typeof fieldValue === 'object' && fieldValue !== null) {
      return Object.values(fieldValue).every((nestedValue) => areAllFieldsFilled(nestedValue))
    }

    const isCompleteFieldId = skipKeyId ? true : fieldValue !== null

    return fieldValue !== '' && isCompleteFieldId
  }

  return Object.values(values).every((value) => areAllFieldsFilled(value))
}

export const isDefaultVesselImg = (url = '') => {
  const emptyVesselFileName = 'vessel_default.webp'
  const fileName = url.split('/').pop()

  return fileName === emptyVesselFileName
}
